import * as React from 'react'
import { ReactElement, useState } from 'react'
import { Menu, MenuDivider, MenuItemRadio, MenuList, MenuPopover, MenuTrigger, ToolbarButton } from '@fluentui/react-components'
import {
    ArrowRightFilled,
    ArrowRightRegular,
    bundleIcon,
    FilterFilled,
    FilterRegular,
    MailFilled,
    MailInboxFilled,
    MailInboxRegular,
    MailRegular,
} from '@fluentui/react-icons'
import { MailDirection } from '../../Email/EmailSearchSelectList'
import { EmailToolbarProps } from './EmailToolbar'
import { useTranslation } from 'react-i18next'

const FilterIcon = bundleIcon(FilterFilled, FilterRegular)
const MailInboxIcon = bundleIcon(MailInboxFilled, MailInboxRegular)
const ArrowRightIcon = bundleIcon(ArrowRightFilled, ArrowRightRegular)
const MailIcon = bundleIcon(MailFilled, MailRegular)

export default function EmailDirectionMenu(props: EmailToolbarProps): ReactElement {
    const { t: translate } = useTranslation()

    const [checkedValues, setCheckedValues] = useState<Record<string, MailDirection[]>>({
        direction: [props.direction],
    })

    return (
        <Menu
            checkedValues={checkedValues}
            onCheckedValueChange={(e, d) => {
                setCheckedValues({ [d.name]: d.checkedItems as MailDirection[] })
                props.setDirection(d.checkedItems[0] as MailDirection)
            }}
        >
            <MenuTrigger>
                <ToolbarButton icon={<FilterIcon />} disabled={props.isLoading} />
            </MenuTrigger>
            <MenuPopover>
                <MenuList>
                    <MenuItemRadio icon={<MailInboxIcon />} name={'direction'} value={MailDirection.In}>
                        {translate('email.filing.filter.sorting.in')}
                    </MenuItemRadio>
                    <MenuItemRadio icon={<ArrowRightIcon />} name={'direction'} value={MailDirection.Out}>
                        {translate('email.filing.filter.sorting.out')}
                    </MenuItemRadio>
                    <MenuDivider />
                    <MenuItemRadio icon={<MailIcon />} name={'direction'} value={MailDirection.Both}>
                        {translate('email.filing.filter.sorting.both')}
                    </MenuItemRadio>
                </MenuList>
            </MenuPopover>
        </Menu>
    )
}
